import React, { useState } from "react";
import logo from '../assets/images/logo.png'
import menuIco from '../assets/images/Union.svg'
const Navbar = () => {

  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
      <a className="navbar-brand fw-bold" href="https://www.spurtreetech.com/">
        <img src={logo} alt="Spurtree" className="me-2" />
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        {/* <span className="navbar-toggler-icon"></span> */}
        <img src={menuIco} alt="menu" />
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ms-auto">
          <li className="nav-item">
            <a className="nav-link" href="https://www.spurtreetech.com/about-us/">
              About Us
            </a>
          </li>
          <li
            className="nav-item dropdown"
            onMouseEnter={() => setShowServicesDropdown(true)}
            onMouseLeave={() => setShowServicesDropdown(false)}
          >
            <a
              className="nav-link dropdown-toggle"
              href="https://www.spurtreetech.com/our-services/"
              role="button"
              aria-expanded={showServicesDropdown}
            >
              Our Services
            </a>
            <ul className={`dropdown-menu ${showServicesDropdown ? "show" : ""}`}>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/enterprise-digital-transformation/">
                Enterprise Digital Transformation
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/application-modernization/">
                Application Modernization
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/big-data-analytics/">
                Big Data & Analytics
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/cloud/">
                Cloud
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/design-experience/">
                Design & Experience
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/mobile-web-application-development/">
                Mobile & Web Application Development
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/ai-services/">
                AI services
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/emerging-startups/">
                Emerging Startups
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/sap-solutions/">
                SAP Solutions
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/quality-assurance/">
                Quality assurance
                </a>
              </li>
            </ul>
          </li>

          {/* Dropdown for Industries */}
          <li
            className="nav-item dropdown"
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              aria-expanded={showDropdown}
            >
              Industries
            </a>
            <ul className={`dropdown-menu ${showDropdown ? "show" : ""}`}>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/retail/">
                  Retail
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/energy/">
                  Energy
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/governance/">
                  Governance
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/manufacturing/">
                  Manufacturing
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/healthcare-pharma/">
                  Healthcare & Pharma
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/information-services/">
                  Information Services
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.spurtreetech.com/travel-hospitality/">
                  Travel & Hospitality
                </a>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <a className="nav-link" href="https://www.spurtreetech.com/blogs/">
              Blogs
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="https://www.spurtreetech.com/contact-us/">
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
